import React from 'react';
import { makeStyles, Table, Typography } from '@material-ui/core';
import TableComponents from 'components/Table';
import { MetaType } from 'store/modules/Meta/types';
import AssetClass from './AssetClass';
import { getFormValues } from 'redux-form';
import { compose } from 'ramda';
import Store from 'store/store';
import { formatPercent, unFormatPercent } from 'utils';
const { connect } = Store;

const useStyles = makeStyles({
  headRow: {
    '& th': {
      padding: '0 1rem'
    }
  }
});

interface AssetClassesProps {
  fields: any;
  assetClasses: Array<MetaType>;
  values: any;
}

const AssetClasses = ({ fields, assetClasses, values }: AssetClassesProps) => {
  const classes = useStyles();
  const isAnyFieldExist = fields.length > 0;
  const removeAsset = (index: number) => fields.remove(index);

  const getTotal = () => {
    return values.asset_classes.reduce(
      (acc: number, curr: any) =>
        acc + Number(unFormatPercent(curr.percentage_value)),
      0
    );
  };

  return isAnyFieldExist ? (
    <div>
      <Typography style={{ marginBottom: '1rem' }} variant="subtitle2">
        Internal asset allocation
      </Typography>
      <Table>
        <TableComponents.TableHead
          className={classes.headRow}
          cells={['%', 'Asset class', '']}
        />
        <TableComponents.TableBody>
          {fields.map((assetClass: string, index: number) => {
            return (
              <AssetClass
                key={index}
                field={assetClass}
                assetClasses={assetClasses}
                removeAsset={removeAsset}
                index={index}
              />
            );
          })}
          <TableComponents.TableRow>
            <TableComponents.TableCell>
              <span style={{ color: '#0080bd', fontWeight: 600 }}>
                {formatPercent(getTotal())}
              </span>
            </TableComponents.TableCell>
            <TableComponents.TableCell />
            <TableComponents.TableCell />
          </TableComponents.TableRow>
        </TableComponents.TableBody>
      </Table>
    </div>
  ) : null;
};

export default compose(
  connect((state: any) => ({
    values: getFormValues('manualFund')(state)
  }))
)(AssetClasses);
